import type { Currency } from '../types'

const CURRENCY_SYMBOLS: Record<Currency, string> = {
  GBP: '£',
  USD: '$',
  EUR: '€',
  CAD: 'C$',
  AUD: 'A$',
}

export function formatCurrency(
  amountInCents: number,
  currency: string
): string {
  const symbol = CURRENCY_SYMBOLS[currency as Currency] ?? currency
  const amount = amountInCents / 100
  return `${symbol}${amount.toLocaleString('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`
}

export function parseCurrencyInput(value: string): number {
  const cleaned = value.replace(/[^0-9.]/g, '')
  const parsed = parseFloat(cleaned)
  if (isNaN(parsed)) return 0
  return Math.round(parsed * 100)
}

export function formatCurrencyInput(amountInCents: number): string {
  return (amountInCents / 100).toFixed(2)
}
